import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PeriodDropdown from '../shared/periodDropdown.component';
import { fetchCommunications, selectPeriodForDashboard } from './store/actions';
import ConnectionRunStatusWidget from './connectionRunStatusWidget/connectionRunStatusWidget.component';
import ProvisionQualityWidget from './provisionQualityWidget/provisionQualityWidget.component';
import NotificationsWidget from './notificationsWidget.component';
import ProvisionsTableWidget from './provisionsTableWidget.component';
import SecondaryMenu from '../menu/secondaryMenu.component';
import ServiceAnnouncementsContainer from './serviceAnnouncements/serviceAnnouncementsContainer.component';
import ExpirationBannerComponent from '../shared/expirationBanner/expirationBanner.component';
import { periodsSelector, isFetchingCompanyCodesSelector } from '../shared/store/selectors';
import { twoWeeksBeforeDate, isBetweenDates } from '../shared/dateHelpers';

class Dashboard extends PureComponent {
  static propTypes = {
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
    periods: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
    })).isRequired,
    selectPeriodForDashboard: PropTypes.func,
    fetchCommunications: PropTypes.func.isRequired,
    isFetchingCompanyCodes: PropTypes.bool.isRequired,
    lastClientId: PropTypes.number,
    clients: PropTypes.arrayOf(PropTypes.shape({
      clientId: PropTypes.number.isRequired,
      expirationDate: PropTypes.string,
    })),
  };

  componentDidMount() {
    const { fetchCommunications } = this.props;
    fetchCommunications();
  }

  selectPeriod = selectedPeriod => {
    const { periods } = this.props;
    const value = selectedPeriod ? selectedPeriod.value : null;
    this.props.selectPeriodForDashboard(periods.find(period => period.name === value));
  };

  findLastClientExpirationDate = () => {
    const { lastClientId, clients } = this.props;
    if (!clients || !clients.length) {
      return null;
    }
    const client = clients.find(c => c.clientId === lastClientId);
    return client?.expirationDate || null;
  };

  isLastClientAboutToExpired = () => {
    const { lastClientId, clients } = this.props;
    if (!clients || !clients.length) {
      return false;
    }
    const lastClient = clients.find(client => client.clientId === lastClientId);
    if (!lastClient?.expirationDate) {
      return false;
    }
    return isBetweenDates(twoWeeksBeforeDate(lastClient.expirationDate), lastClient.expirationDate);
  };

  render() {
    const {
      isFetchingCompanyCodes,
    } = this.props;

    return (
      <div className="dashboard">
        <SecondaryMenu>
          <PeriodDropdown
            onChange={this.selectPeriod}
            disabled={isFetchingCompanyCodes}
          />
        </SecondaryMenu>
        <div className="page">
          <ExpirationBannerComponent
            expirationDate={this.findLastClientExpirationDate()}
            isAboutToExpire={this.isLastClientAboutToExpired()}
          />
          <ServiceAnnouncementsContainer />
          <div className="row dashboard-column-gutter">
            <div className="col-md-12 col-xl-8">
              <div className="row">
                <div className="col-12">
                  <ProvisionsTableWidget />
                </div>
              </div>
            </div>
            <div className="col-md-12 col-xl-4">
              <div className="row dashboard-column-gutter">
                <div className="col-md-6 col-xl-12">
                  <NotificationsWidget
                    isLoading={isFetchingCompanyCodes}
                  />
                </div>
                <div className="col-md-6 col-xl-12">
                  <ConnectionRunStatusWidget />
                </div>
                <div className="col-md-6 col-xl-12">
                  <ProvisionQualityWidget />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { shared } = state;

  return {
    period: shared.period,
    periods: periodsSelector(state),
    isFetchingCompanyCodes: isFetchingCompanyCodesSelector(state),
    lastClientId: state.user.user.lastClientId,
    clients: state.user.clients,
  };
}

export default connect(
  mapStateToProps,
  {
    selectPeriodForDashboard,
    fetchCommunications,
  }
)(Dashboard);
